import {E} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Column, Row} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {DefaultSkin, Observer} from "web-vcore";
import {RNG_SFC32} from "../../../Utils/General/RNG/PRNGs/RNG_SFC32.js";
import {JournalSegment} from "../../../Server/DB/journalEntries/@JournalEntry.js";
import {HashString} from "../../../Utils/General/General.js";

export const DreamEventsUI = observer_mgl((props: {segment: JournalSegment, events: string[], activeInVR?: boolean, activeEventIndex?: number, forVR?: boolean, style?})=>{
	let {segment, events, activeInVR, activeEventIndex = -1, forVR, style} = props;
	if (events.length == 0) return null;

	const ContainerType = forVR ? Column : Row;
	//const highlightedEventIndexes_ordered = highlightedEventIndexes?.OrderBy(a=>a);
	return (
		<ContainerType style={E(
			{
				position: "relative",
				fontFamily: DefaultSkin.main.MainFont(), // include Symbola font, to avoid the system-font's overly-distracting colored emojis
			},
			!forVR && {flexWrap: "wrap"},
			forVR && {
				alignItems: "flex-start",
				fontFamily: "Arial, sans-serif",
				padding: 7, // need padding around it, for the drop-shadow (when active)
			},
			activeInVR && {
				//border: "1px solid white",
				filter: "drop-shadow(0 0 3px rgba(0,150,255,1)) drop-shadow(0 0 3px rgba(0,150,255,1))",
			},
			style,
		)}>
			{events.map((event, index)=>{
				return <DreamEventUI key={index} event={event} events={events} highlight={
					/*index == highlightedEventIndexes_ordered?.LastOrX() ? "rgba(255,255,0,.7)" :
					highlightedEventIndexes_ordered?.includes(index) ? "rgba(64,128,64,.7)" :
					null*/
					index == activeEventIndex ? "rgba(200,150,0,1)" : // full opacity, else blue glow changes color/appearance too much
					index < activeEventIndex ? "rgba(64,128,64,.7)" :
					null
				} forVR={forVR}/>;
			})}
		</ContainerType>
	);
});

export const DreamEventUI = (props: {event: string, events: string[], highlight?: string|n, forVR?: boolean})=>{
	const {event, events, highlight, forVR} = props;
	//const index = events.indexOf(event);

	return (
		<Row style={E(
			{
				padding: "0 3px", borderRadius: 5,
				gap: 3,
			},
			!forVR && {
				marginLeft: 3,
				height: "fit-content", // fixes height issue (where height increases to match height of left-anchored action-button)
				backgroundColor: "rgba(0,0,0,.5)", border: "1px solid rgba(255,255,255,.3)",
			},
			forVR && {
				marginTop: 3,
				backgroundColor: "rgba(0,0,0,.7)", border: "1px solid rgba(255,255,255,.5)",
			},
			highlight && {
				backgroundColor: highlight, color: "white", border: "1px solid rgba(255,255,255,1)"
			},
			{cursor: "pointer"},
		)}>
			{event}
		</Row>
	);
};